import { Label, Radio } from 'components/Form'
import { ChangeEvent, FocusEventHandler, useMemo } from 'react'
import { Flex } from 'theme-ui'
import { noop } from 'utils'
import { BasicInputGroup } from './BasicInputGroup'

export interface RadioInputGroupProps {
  name: string
  options: {
    label: string
    value: string
  }[]
  label: string
  value?: string
  error?: string
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void
  onBlur?: FocusEventHandler
  disabled?: boolean
  tabIndex?: number
}

export const RadioInputGroup = ({
  options,
  value,
  name,
  label,
  error,
  setFieldValue,
  onBlur = noop,
  disabled,
  tabIndex,
}: RadioInputGroupProps) => {
  const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const {
      target: { name, value },
    } = evt
    setFieldValue(name, value)
  }

  const displayText = useMemo(
    () => options.find((option) => option.value === value)?.label || '-',
    [options, value]
  )
  return (
    <BasicInputGroup
      name={name}
      label={label}
      disabled={disabled}
      error={error}
      display={displayText}
      input={
        <Flex variant="forms.inputGroup.radio" role="radiogroup">
          {options.map((option, idx) => (
            <Label key={option.value} variant="layout.labelWithRadio">
              <Radio
                name={name}
                value={option.value}
                checked={option.value === value}
                disabled={disabled}
                onChange={handleChange}
                onBlur={onBlur}
                tabIndex={tabIndex ? tabIndex + (idx + 1) / 100 : tabIndex}
              />
              {option.label}
            </Label>
          ))}
        </Flex>
      }
    />
  )
}
